import { MessageType } from '../../../components/core-v2/atoms/types/types'
import { PortfolioStatus } from '../constants'

export const portfolioApprovalStatusCircleColorMap: Partial<Record<PortfolioStatus, MessageType>> =
  {
    Active: 'success',
    New: 'error'
  }
